export enum ACTION_TYPES {
  FETCH_CREDIT_REPORT = 'FETCH_CREDIT_REPORT',
  FETCH_CREDIT_REPORT_SUCCESS = 'FETCH_CREDIT_REPORT_SUCCESS',
  FETCH_CREDIT_REPORT_FAIL = 'FETCH_CREDIT_REPORT_FAIL',
  FETCH_CREDIT_REPORTS = 'FETCH_CREDIT_REPORTS',
  FETCH_CREDIT_REPORTS_SUCCESS = 'FETCH_CREDIT_REPORTS_SUCCESS',
  FETCH_CREDIT_REPORTS_FAIL = 'FETCH_CREDIT_REPORTS_FAIL',
}
